import React from 'react';
import Icon from 'components/AppIcon';

const MetricsStrip = ({ metrics }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metrics?.map((metric) => (
        <div
          key={metric?.id}
          className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-4 lg:p-5 shadow-sm hover:shadow-md transition-shadow cursor-pointer group"
        >
          <div className="flex items-start justify-between mb-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${metric?.color}18` }}
            >
              <Icon name={metric?.icon} size={20} color={metric?.color} strokeWidth={2} />
            </div>
            <span
              className={`text-xs font-medium px-2 py-1 rounded-full font-caption ${
                metric?.trend === 'up' ?'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : metric?.trend === 'down' ?'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' :'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
              }`}
            >
              {metric?.trend === 'up' ? '↑' : metric?.trend === 'down' ? '↓' : '→'} {metric?.change}
            </span>
          </div>
          <div className="mt-2">
            <p className="text-2xl lg:text-3xl font-bold font-heading text-[var(--color-foreground)]">
              {metric?.value}
            </p>
            <p className="text-sm font-medium text-[var(--color-foreground)] mt-0.5 font-caption">
              {metric?.label}
            </p>
            <p className="text-xs text-[var(--color-muted-foreground)] mt-1 font-caption">
              {metric?.subLabel}
            </p>
          </div>
          <div className="mt-3 pt-3 border-t border-[var(--color-border)]">
            <div className="flex items-center gap-1">
              <div className="flex-1 bg-[var(--color-muted)] rounded-full h-1.5">
                <div
                  className="h-1.5 rounded-full transition-all duration-500"
                  style={{ width: `${metric?.progress}%`, backgroundColor: metric?.color }}
                />
              </div>
              <span className="text-xs text-[var(--color-muted-foreground)] font-caption ml-1">
                {metric?.progress}%
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsStrip;